var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicpenGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magicpen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9829 11.3186C17.4612 11.4429 16.8535 11.6526 16.2576 12.0056C15.1766 12.6459 14.1715 13.7374 13.7664 15.5415C13.3622 13.7285 12.3562 12.6352 11.2729 11.9961C10.6731 11.6423 10.0613 11.4341 9.53751 11.312C10.0529 11.1888 10.6516 10.9822 11.2394 10.6362C12.3249 9.99743 13.3357 8.90413 13.7417 7.08994C14.1478 8.90425 15.1593 9.99769 16.2473 10.6365C16.847 10.9886 17.4586 11.1964 17.9829 11.3186Z",
    fill: "#6C6F74",
    stroke: "#6C6F74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.00328 4.99712C7.37768 5.3648 6.80308 5.99508 6.57588 7.02922C6.35431 5.98194 5.78075 5.34455 5.15217 4.9735C4.79751 4.76413 4.43585 4.64546 4.13066 4.57832C4.43278 4.51082 4.79074 4.39257 5.14251 4.18584C5.78237 3.80977 6.36888 3.15901 6.5849 2.08238C6.80093 3.15901 7.38743 3.80977 8.0273 4.18584C8.3984 4.40394 8.77642 4.52356 9.08848 4.589C8.77191 4.65329 8.38396 4.77339 8.00328 4.99712Z",
    fill: "#6C6F74",
    stroke: "#6C6F74",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.38997 15.8046C2.0353 15.5952 1.67364 15.4765 1.36845 15.4094C1.67057 15.3419 2.02854 15.2236 2.3803 15.0169C3.02016 14.6408 3.60667 13.9901 3.8227 12.9134C4.03872 13.9901 4.62523 14.6408 5.26509 15.0169C5.6362 15.235 6.01421 15.3546 6.32627 15.4201C6.0097 15.4843 5.62176 15.6044 5.24108 15.8282C4.61547 16.1959 4.04088 16.8261 3.81367 17.8603C3.5921 16.813 3.01854 16.1756 2.38997 15.8046Z",
    fill: "#6C6F74",
    stroke: "#6C6F74",
    strokeWidth: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicpenGrey);
export default __webpack_public_path__ + "static/media/magicpenGrey.80a6ce73a7ca0e89a5f3c766ef31232f.svg";
export { ForwardRef as ReactComponent };